import { AfterViewInit, Component, ElementRef, ViewChild, ViewEncapsulation } from "@angular/core";

import { ICellEditorAngularComp } from "ag-grid-angular";
import { SelectItem } from "primeng/api";

@Component({
    selector: 'dropdown-cell',
    templateUrl: 'g-dropdown.component.html',
    styleUrls: ['g-dropdown.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class AGDropdownEditorComponent implements ICellEditorAngularComp, AfterViewInit {
    private params: any;
    public value: string;
    public options: SelectItem[] = [];

    @ViewChild('dropdown') public dropdown: ElementRef<HTMLElement>;

    agInit(params: any): void {
        this.params = params;
        this.value = this.params.value;
        this.options = [];
        this.params.values.forEach(e => {
            this.options.push({
                label: e.label,
                value: e.label
            })
        });;
    }

    getValue(): any {
        return this.value;
    }

    // dont use afterGuiAttached for post gui events - hook into ngAfterViewInit instead for this
    ngAfterViewInit() {
        setTimeout(() => {
            this.dropdown.nativeElement.focus();
        })
    }
}